import { useState, useEffect } from "react";
import axios from "axios";
import { useSEO } from "@/hooks/useSEO";
import { StallSelection } from "./screens/StallSelection";
import { BusinessDetails } from "./screens/BusinessDetails";
import { PaymentScreen } from "./screens/PaymentScreen";
import { ConfirmationScreen } from "./screens/ConfirmationScreen";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function VendorBooking() {
  useSEO("Book a Stall | The Market Place Jaipur", "Book a stall at The Market Place, Jaipur in a few simple steps.");
  const [screen, setScreen] = useState(1);
  const [data, setData] = useState({ selected_dates: [], stall_selections: [] });
  const [referenceId, setReferenceId] = useState(null);
  const [returningFromPayment, setReturningFromPayment] = useState(true);

  const goTo = (n) => {
    setScreen(n);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const orderId = new URLSearchParams(window.location.search).get("order_id");
    if (!orderId) {
      setReturningFromPayment(false);
      return;
    }
    let attempts = 0;
    const verify = async () => {
      try {
        await axios.post(`${API}/vendor/verify-payment`, { reference_id: orderId });
      } catch (err) {
        // ignore — confirmation screen will show current backend status regardless
      }
      attempts += 1;
      if (attempts < 4) {
        setTimeout(verify, 2000);
      } else {
        setReferenceId(orderId);
        setReturningFromPayment(false);
        setScreen(4);
      }
    };
    verify();
  }, []);

  if (returningFromPayment) {
    return (
      <div data-testid="vendor-booking-verifying" className="min-h-[80vh] flex items-center justify-center px-6">
        <p className="text-gray-400 font-mono text-sm">Confirming your payment with PhonePe...</p>
      </div>
    );
  }

  return (
    <div data-testid="vendor-booking-page" className="min-h-[80vh] px-6 sm:px-8 py-16">
      <div className="max-w-3xl mx-auto mb-10">
        <div className="flex items-center justify-center gap-2" data-testid="vendor-progress-bar">
          {[1, 2, 3, 4].map((n) => (
            <div key={n} className={`h-1.5 rounded-full flex-1 transition-colors duration-500 ${n <= screen ? "bg-[#D81B60]" : "bg-gray-200"}`} />
          ))}
        </div>
      </div>

      {screen === 1 && <StallSelection data={data} setData={setData} onNext={() => goTo(2)} />}
      {screen === 2 && <BusinessDetails data={data} setData={setData} onNext={() => goTo(3)} onBack={() => goTo(1)} />}
      {screen === 3 && <PaymentScreen data={data} onBack={() => goTo(2)} />}
      {screen === 4 && referenceId && <ConfirmationScreen referenceId={referenceId} />}
    </div>
  );
}
